<template>
    <div  class="empty-data">

        <div v-if="isFavorites" class="empty-data__favorites">
            <div class="empty-data__favorites-title">{{ emptyGuideTitle }}</div>
            <div class="empty-data__favorites-msg">{{ emptyGuideMsg }}</div>
            <button 
                id="btnEmptyDataFavorites"
                class="empty-data__favorites-btn btn"
                @click="goToSettingsFavoritesPage"
                @focus="onFocus"
                @blur="onBlur"
            >
                {{emptyGuideBtn}}
            </button>
        </div>

        <div v-else class="empty-data__text">{{ emptyGuideText }}</div>
    </div>
</template>

<script lang="ts" setup>
    import { Strings } from "@/locales/types/enums";
    import { useI18n } from "vue-i18n";
    import { useGuideStore } from "@/stores/Guide";
    import { FilterTabsType } from "@/stores/Guide/types";
    import { linkItems } from "@/components/Header/types";

    const GuideStoreModule = useGuideStore();
    const {
        filterParams
    } = storeToRefs(GuideStoreModule);

    const { focusToHeader } = useFocus();

    const { $navigator } = useNuxtApp();
    const { t } = useI18n();

    let isRegKeyListeners: boolean = false;
    const emptyGuideText: string = t(Strings.GUIDE_EMPTY_DATA).toString();
    const emptyGuideTitle: string = t(Strings.GUIDE_EMPTY_DATA_TITLE).toString();
    const emptyGuideMsg: string = t(Strings.GUIDE_EMPTY_DATA_MSG).toString();
    const emptyGuideBtn: string = t(Strings.GUIDE_EMPTY_DATA_BTN).toString();
    const isFavorites = computed((): boolean => filterParams.value === FilterTabsType.FAVOURITES);
    const router = useRouter();

    const focusToFilter = inject<() => void>('focusToFilter');

    const goToSettingsFavoritesPage = (): void => {
        void router.push({ 'path': linkItems.settings.routerPath, query: {'linkItemCode': linkItems.favorites.code }});
    };
    const registerKeyListeners = (): void => {
        if (isRegKeyListeners) {
            return;
        }

        $navigator.on("keypress:back", focusToHeader);
        if(focusToFilter) {
            $navigator.on("keypress:up", focusToFilter);
        }
        isRegKeyListeners = true;
    };
    const unregisterKeyListeners = (): void => {
        if (!isRegKeyListeners) {
            return;
        }

        $navigator.off("keypress:back", focusToHeader);
        if(focusToFilter) {
            $navigator.off("keypress:up", focusToFilter);
        }
        isRegKeyListeners = false;
    };
    const onFocus = (): void => {
        registerKeyListeners();
    };
    const onBlur = (): void => {
        unregisterKeyListeners();
    };

    onBeforeUnmount(() => {
        unregisterKeyListeners();
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>